import isUndefined from "lodash/isUndefined";
import { SelectV2, SelectV2Props } from "PFComponents/select_v2";
import { PureCustomValue } from "PFTypes";
import { Option } from "PFTypes/options";

import { ValuesList } from "./values_list";

export type OptionOriginal = PureCustomValue & {
  expiryDate?: string | null;
};

export type CustomValueOption = Option<OptionOriginal>;

export type CustomValueSelectProps = SelectV2Props<OptionOriginal> & {
  onDateChange?: (option: Option<OptionOriginal>) => void;
  withExpiryDate?: boolean;
  displayValues?: React.ReactNode | null;
};

export const CustomValueSelect = (props: CustomValueSelectProps) => {
  const {
    multiple,
    onChange,
    onDateChange,
    onClear,
    withExpiryDate,
    displayValues,
    disabled,
    locked,
    tabIndex
  } = props;

  const formatSelectedOptions = (selectedOptions: CustomValueOption | CustomValueOption[]) =>
    Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions];

  const renderDisplayValue = (selectedOptions) =>
    isUndefined(displayValues) ? (
      <ValuesList
        selectedOptions={formatSelectedOptions(selectedOptions || [])}
        onChange={onChange}
        onClear={onClear}
        onDateChange={onDateChange}
        withExpiryDate={withExpiryDate}
        multiple={multiple}
        disabled={disabled || locked}
        tabIndex={tabIndex}
      />
    ) : (
      displayValues
    );

  return <SelectV2<OptionOriginal> {...props} renderDisplayValue={renderDisplayValue} />;
};
